import React from 'react';
import Image from '../../../components/AppImage';

const HeroBanner = () => {
  return (
    <div className="w-full py-1 md:py-2">
      <div className="max-w-9xl mx-auto">
        <div className="relative w-full h-24 md:h-64 lg:h-60 ">
          

          <Image
            src="/assets/images/banner yeslamo.svg"
            className="w-full h-full object-cover" />

        </div>
      </div>
    </div>
    );

};

export default HeroBanner;